import Vue from 'vue'
import axios from 'axios';

Vue.prototype.$listarTiposAssunto = async () =>{
    try { 
      let res = await axios.get('manifestacao/tipos/todos',{});
      return res.data;
    } catch (e) {
      throw e;
    }  
}